import { Text } from '@mantine/core';
import { IconX, IconCircleCheck } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AICompletionCard({ message }: { message: Extract<AIMessage, { type: 'completion' }> }) {
  const title = message.success ? 'Completion Success' : 'Completion Failed';

  return (
    <CollapsibleCard
      icon={message.success ? IconCircleCheck : IconX}
      title={title}
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div className="space-y-1">
        <div className="mx-1 rounded px-2 py-1.5">
          <Text
            size="sm"
            className="leading-relaxed"
          >
            {message.content}
          </Text>
        </div>
      </div>
    </CollapsibleCard>
  );
}
